<template>
	<div class="table-inner">
		<div class="row">
			<template v-for="(field, name, index) in tableData.fields" :key="index">
				<div class="table-row col-12" :class="[isMultiblock == 'false' ? 'col-md-6 non-multi' : '' ]" v-if="field !== '' && field !=='Nein' &&  field !=='keine Angabe' && field !=='-'">
					<div class="row">
						<div class="table-column col-sm-6 pe-sm-0">
							<span>{{ name }}</span>
						</div>

						<div class="table-column col-sm-6 ps-sm-0">
							<span v-if="field === true" class="table-icon">
								<svg version="1.1" id="Ebene_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 -10 50 50" style="enable-background:new 0 0 44 42;" xml:space="preserve">
									<path id="Pfad_3373" class="st0" d="M2.5,14.7l13.6,13.6L42.5,2.8"/>
								</svg>
							</span>
							<span v-else v-html="field"></span>
						</div>
					</div>
				</div>
			</template>
		</div>
	</div>
</template>

<script>

export default {
	props: {
		tableData: {
			type: Object
		},
		index: {
			type: Number
		},
		isMultiblock: {
			type: String
		}
	},
};

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "@/assets/scss/design-aachen/tableItemsComponent.scss";
</style>